<template>
  <div>
    You are logged in!
  </div>
</template>

<script>
export default {
  name: 'Main',
  data: function() {
    return {
      hello: 'world',
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue